import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { empty, Observable, Subject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import {
  IApiResultResponse, IBaseResponse, IFinishes,
  IFilterItemRequest,
  IGetItemSuggestionsBody, ItemSearchCritera, ItemSuggestion, MasterData, SearchItemResultPageResource, BaseResponse, IItemCatalog
} from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { UserService } from './user.service';
@Injectable({
  providedIn: 'root'
})
export class ItemService {

  public results: any[];

  public path: string;
  public loading: boolean;
  /* discuss and refactor this class */
  constructor(private httpClient: HttpClient, private userService: UserService) {
    this.results = [];
    this.path = ``;
    this.loading = false;
  }
  //public searchCriteria: ItemSearchCritera = new ItemSearchCritera();
  public searchCriteria: ItemSearchCritera = new ItemSearchCritera();
  ResetSearchForm: Subject<boolean> = new Subject<boolean>();
  //#region MasterDataService Api endPoints
  public getItemSuggestions(body: IGetItemSuggestionsBody): Observable<ItemSuggestion[]> {
   // const endPoint = `${ConfigService.APIs.endPoints.ITEM.GET_SUGGESTION}/${body.searchstring}/${body.categoryId}`;
    const endPoint = `${ConfigService.APIs.endPoints.ITEM.GET_SUGGESTION}`;
    body.customerNumber = this.userService.readUserObject.customerNumber;
    body.countryCode= this.userService.readUserObject.countryCode;
    return ApiService.genericObservablePost(this.httpClient, endPoint,body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }), //Testing Purpose
        map((response: IBaseResponse) => response.data),
        ////tap((response) => { console.log(response); })     //Testing Purpose
      );;
  }
  public filterItems(body: IFilterItemRequest): Observable<SearchItemResultPageResource> {
    const endPoint = `${ConfigService.APIs.endPoints.ITEM.FILTER_ITEMS}`;
    body.countryCode= this.userService.readUserObject.countryCode;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }

  public getItemDetails(itemNumber: string, customerNumber: string): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ITEM.GET_ITEM_DETAILS}`;
    const body = { customerNumber: customerNumber, itemNumber: itemNumber, countryCode : this.userService.readUserObject.countryCode };
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public getFinishesNew(): Observable<Array<IFinishes>> {
    const endPoint = `${ConfigService.APIs.endPoints.ITEM.GET_FINISHES_NEW}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(tap((finishes) => { this.finishes = finishes }));
  }

  private FINISHES: Array<IFinishes> = [];
  public get finishes(): Array<IFinishes> {
    if (!this.FINISHES) {
      this.FINISHES = [];
    }
    return this.FINISHES;
  }
  public set finishes(finishes: Array<IFinishes>) {
    this.FINISHES = finishes;
  }
  //#endregion

  //#region commonly orders items
  getCommonlyOrderedItems(body:any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ITEM.GET_COMMONLY_ORDER}`;   
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion
  //#region Associate/disassociate items
  getAssociateItems(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ITEM.GET_ASSOCIATE_ITEM}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  saveAssociateItems(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ITEM.SAVE_ASSOCIATE_ITEM}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  disasociateItems(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ITEM.DISASSOCIATE_ITEM}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public deleteItem(body: any): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.ITEM.DELETE_ITEM}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  //#endregion
}
